import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

export interface RangePickerData {
  min: number;
  max?: number;
}

const DEFAULT_OPTIONS: Options = {
  animate: false
};

@Component({
  selector: 'ui-range-picker',
  templateUrl: './range-picker.component.html',
  styleUrls: ['./range-picker.component.scss']
})
export class RangePickerComponent implements OnChanges {
  @Input()
  options: Options = DEFAULT_OPTIONS;
  @Input()
  value: number;
  @Input()
  maxValue: number;
  @Input()
  manualRefresh: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  onChangeStart: EventEmitter<RangePickerData> = new EventEmitter<RangePickerData>();
  @Output()
  onChanging: EventEmitter<RangePickerData> = new EventEmitter<RangePickerData>();
  @Output()
  onChange: EventEmitter<RangePickerData> = new EventEmitter<RangePickerData>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options && changes.options.currentValue) {
      this.options = { ...DEFAULT_OPTIONS, ...this.options };
    }
  }

  public changeStart(evt: ChangeContext): void {
    this.emitChangedValues(evt);
  }

  public changing(evt: ChangeContext): void {
    this.emitChangedValues(evt);
  }

  public changed(evt: ChangeContext): void {
    this.emitChangedValues(evt);
  }

  private emitChangedValues(evt: ChangeContext) {
    // Hotfix for https://itonics.atlassian.net/browse/CEX-712
    // Workaround due to a weird issue found in ngx-slider
    // the output event of the slider tends to return NaN
    // instead of the min/floor value of the range in the
    // cases when the default 'value' is null or undefined and
    // the min (leftmost) step/point of the range/slider bar is clicked
    if (Number.isNaN(this.value)) {
      let minRange = 0;
      if (this.options.stepsArray && this.options.stepsArray.length) {
        minRange = this.options.stepsArray[0].value;
      } else if (this.options.floor !== null && this.options.floor !== undefined) {
        minRange = this.options.floor;
      }
      this.value = minRange;
    }

    const outputEvent: RangePickerData = {
      min: this.value
    };
    if (evt.highValue !== undefined) {
      outputEvent.max = evt.highValue;
    }
    this.onChange.emit(outputEvent);
  }
}
